import { render, staticRenderFns } from "./HeadBanner.vue?vue&type=template&id=1910c4bc&scoped=true&"
import script from "./HeadBanner.vue?vue&type=script&lang=js&"
export * from "./HeadBanner.vue?vue&type=script&lang=js&"
import style0 from "./HeadBanner.vue?vue&type=style&index=0&id=1910c4bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1910c4bc",
  null
  
)

export default component.exports